var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"pic-url",attrs:{"src":_vm.picUrl}})
}
var staticRenderFns = []

export { render, staticRenderFns }